<template>
    <div class="object-root">
        <div v-for="( obj, key ) in data" :key="key" :class="{ 'object': true, 'isExpanded': isExpanded[key] }">
            <div class="header" @click.prevent="isExpanded = { ...isExpanded, [key]: !isExpanded[key] }">
                <span v-show="!isExpanded[key]">
                    <i class="far fa-chevron-right"></i>
                </span>
                <span v-show="isExpanded[key]">
                    <i class="far fa-chevron-down"></i>
                </span>
                <p v-if="obj instanceof Array">{{ key }} <i class="instance">Array</i></p>
                <p v-else-if="obj instanceof Object">{{ key }} <i class="instance">Object</i></p>
                <p v-else-if="typeof obj === 'string'">{{ key }} <i class="instance">String</i></p>
                <p v-else-if="typeof obj === 'number'">{{ key }} <i class="instance">Number</i></p>
                <p v-else-if="typeof obj === 'boolean'">{{ key }} <i class="instance">Boolean</i></p>
                <p v-else-if="obj === null">{{ key }} <i class="instance">Null</i></p>
                <p v-else>{{ key }}</p>
                <span class="copy" @click.stop="copy(key)"><i class="far fa-copy"></i></span>
            </div>
            <BaseJson :data="obj" v-if="typeof obj == 'object' && obj !== null"></BaseJson>
            <div :class="{ 'object end': true, 'isExpanded': isExpanded[key] }" v-else>
                <div class="header">
                    <p>{{ obj === null ? 'null' : obj }}</p>
                    <span class="copy" @click.stop="copy(obj)"><i class="far fa-copy"></i></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseJson',
  data() {
    return {
      isExpanded: {},
    };
  },
  props: {
    data: {
      required: true,
      type: [Object, Array, String],
    },
    expand: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    Object.keys(this.data).forEach((key) => {
      this.isExpanded[key] = this.expand;
    });
  },
  methods: {
    copy(val) {
      const dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = val;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },
  },
};
</script>

<style lang="scss" scoped>
.object-root {
    padding: 1rem;
    border: 1px solid #888a;
    background-color: #fff;
}

.object {
    overflow: hidden;
    height: 2rem;
    padding-left: .5rem;
    border-left: 1px solid #888a;

    &.end {
        margin-left: 1rem;
        padding: 0rem 0rem 0rem 1rem;
        border-left: 1px solid #888a;
    }

    &.isExpanded {
        height: auto;
    }
}

.header {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 2rem;
    padding: 0;

    &:hover {
        background-color: #0002;
        cursor: pointer;
    }

    .instance {
        color: blue;
        font-size: 12px;
        line-height: .8;
        padding-left: 1rem;
    }

    & + .object-root {
        border: none;
        padding: 0rem 0rem 0rem 1rem;
    }

    span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2rem;
        height: 2rem;

        &.copy {
            &:hover {
                background-color: #0003;
            }
        }
    }

    p {
        display: flex;
        align-items: center;
        margin: 0;
        flex: 1;
        overflow: scroll;
        width: 100%;
        max-height: 40vh;
        line-break: anywhere;

        span {
            width: 100%;
        }
    }
}
</style>
